import { STATUSPAGE } from '@repo/ui';
import { GetActivitiesSummaryByTaskUseCaseInterface } from 'domain/usecases';
import { notifyError } from 'presentation/app/components/notify';
import { useService } from 'presentation/app/hooks/useService';
import {
  clearActivitiesSummaryByTask,
  loadActivitiesSummaryByTask,
} from 'presentation/config/store/reports/activities-summary-by-task-slice';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

export const useActivitiesSummaryByTask = () => {
  // Hooks
  const { reportService } = useService();
  const dispatch = useDispatch();

  //States
  const [loading, setLoading] = useState<STATUSPAGE>(STATUSPAGE.DONE);
  const [selectedSubmitBtn, setSelectedSubmitBtn] = useState<string>();
  const [hasFetchedData, setHasFetchedData] = useState(false);

  // Methods
  const requestHandleActivitiesSummaryByTask = useCallback(
    (params: GetActivitiesSummaryByTaskUseCaseInterface.Params) => {
      setLoading(STATUSPAGE.LOADING);
      reportService
        .handleGetActivitySummaryByTask(params)
        .then((res: any) => {
          let blob = new Blob([res], {
            type: `application/${params?.reportType === '0' ? 'pdf' : 'vnd.openxmlformats-officedocument.spreadsheetml.sheet'}`,
          });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          window.open(link.href, '_blank');
        })
        .catch((err) => {
          notifyError(err.message);
        })
        .finally(() => {
          setLoading(STATUSPAGE.DONE);
        });
    },
    [],
  );

  const requestHandleActivitiesSummaryByTaskJson = useCallback(
    (params: GetActivitiesSummaryByTaskUseCaseInterface.Params) => {
      setLoading(STATUSPAGE.LOADING);
      reportService
        .handleGetActivitySummaryByTask(params)
        .then((res: any) => {
          dispatch(loadActivitiesSummaryByTask(res));
        })
        .catch((err) => {
          notifyError(err.message);
          dispatch(clearActivitiesSummaryByTask());
        })
        .finally(() => {
          setLoading(STATUSPAGE.DONE);
          setHasFetchedData(true);
        });
    },
    [],
  );

  return {
    // States
    loading,
    hasFetchedData,
    selectedSubmitBtn,
    // Methods
    setLoading,
    setSelectedSubmitBtn,
    requestHandleActivitiesSummaryByTask,
    requestHandleActivitiesSummaryByTaskJson,
  };
};
